import React from 'react';
import PropTypes from 'prop-types';

const TestResultView = ({ userTest, masterTest }) => {
  if (!userTest || !masterTest) {
    return <div>Loading test results...</div>;
  }

  return (
    <div className="test-results-container container mt-4">
      <h3 className="mb-4">
        Test Results: <span className="text-info">{masterTest.title}</span>
      </h3>
      <div className="card mb-4">
        <div className="card-body bg-light">
          <h5>Final Score: {userTest.score} / {masterTest.questions.length}</h5>
          <p className="mb-0 text-muted">
            Submitted on: {new Date(userTest.date).toLocaleString()}
          </p>
        </div>
      </div>

      {masterTest.questions.map((question, index) => {
        const userAnswerObj = userTest.questions.find(
          (uq) => String(uq.id) === String(question._id)
        );
        const userAnswerText = userAnswerObj ? userAnswerObj.answer : "Did not answer";

        const isCorrect = question.correctOptions.some(
          (opt) => opt.option === userAnswerText
        );

     
        const allOptions = [...question.correctOptions, ...question.wrongOptions];

        return (
          <div key={question._id} className="card mb-3 shadow-sm">
            <div className="card-header d-flex justify-content-between align-items-center">
              <strong>Question {index + 1}</strong>
              {isCorrect ? (
                <span className="badge badge-success px-3 py-2">Correct</span>
              ) : (
                <span className="badge badge-danger px-3 py-2">Incorrect</span>
              )}
            </div>
            <div className="card-body">
              <p className="lead">{question.statement}</p>
              
              {question.image && (
                <img src={question.image} alt="Question" className="img-fluid mb-3" style={{ maxHeight: '200px' }} />
              )}

              <ul className="list-group list-group-flush mt-3">
                {allOptions.map((opt, i) => {
                  const isThisTheCorrectAnswer = question.correctOptions.some(co => co.option === opt.option);
                  const didUserPickThis = opt.option === userAnswerText;

                  let liClass = "list-group-item ";
                  if (isThisTheCorrectAnswer) {
                    liClass += "list-group-item-success font-weight-bold"; 
                  } else if (didUserPickThis && !isThisTheCorrectAnswer) {
                    liClass += "list-group-item-danger"; 
                  }

                  return (
                    <li key={i} className={liClass}>
                      {opt.option}
                      {didUserPickThis && (
                        <span className="float-right badge badge-dark">Your Answer</span>
                      )}
                      {isThisTheCorrectAnswer && !didUserPickThis && (
                        <span className="float-right badge badge-success">Correct Answer</span>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        );
      })}
    </div>
  );
};

TestResultView.propTypes = {
  userTest: PropTypes.object.isRequired,
  masterTest: PropTypes.object.isRequired,
};

export default TestResultView;